import { useQuery } from '@tanstack/react-query'
import { httpsCallable } from 'firebase/functions'
import { functions, isDevMode } from '@/lib/firebase'

export interface DidYouKnowFact {
  id: string
  fr: string
  en: string
  ln: string
}

export const FALLBACK_FACTS: DidYouKnowFact[] = [
  {
    id: 'f1',
    fr: 'La RDC est l\'un des plus grands producteurs mondiaux de manioc.',
    en: 'The DRC is one of the world\'s largest producers of cassava.',
    ln: 'DRC ezali na manioc mingi koleka na mokili mobimba.',
  },
  {
    id: 'f2',
    fr: 'Mombongo connecte directement les agriculteurs aux acheteurs, sans intermédiaire.',
    en: 'Mombongo connects farmers directly to buyers, with no middleman.',
    ln: 'Mombongo elongi balimi na bato ya kosomba, kozanga moto ya katikati.',
  },
  {
    id: 'f3',
    fr: 'Un score de profil complet augmente vos chances d\'obtenir un financement.',
    en: 'A complete profile score increases your chances of getting financing.',
    ln: 'Score ya profile ozali na likabo ya kosalisa yo kozwa financement.',
  },
  {
    id: 'f4',
    fr: 'Mombongo utilise le paiement mobile (Airtel Money, Orange Money, M-Pesa).',
    en: 'Mombongo supports mobile money: Airtel Money, Orange Money, M-Pesa.',
    ln: 'Mombongo azali kosalela mobile money: Airtel Money, Orange Money, M-Pesa.',
  },
  {
    id: 'f5',
    fr: 'Les prix des cultures sont mis à jour chaque matin sur la Bourse Mombongo.',
    en: 'Crop prices are updated every morning on the Mombongo Exchange.',
    ln: 'Mbongo ya biloko ezali kobongwana sɔ́ngɔ nyonso na Bourse ya Mombongo.',
  },
  {
    id: 'f6',
    fr: 'Avec Academia Mombongo, formez-vous gratuitement en agriculture et finance.',
    en: 'With Mombongo Academia, learn agriculture and finance for free.',
    ln: 'Na Academia ya Mombongo, yekola bilimo ya biloko mpe financement ofele.',
  },
]

export function useDidYouKnow() {
  return useQuery<DidYouKnowFact[]>({
    queryKey: ['did-you-know'],
    queryFn: async () => {
      if (isDevMode()) return FALLBACK_FACTS
      const call = httpsCallable<Record<string, never>, { facts: DidYouKnowFact[] }>(
        functions, 'getDidYouKnowFacts'
      )
      const result = await call({})
      return result.data.facts.length > 0 ? result.data.facts : FALLBACK_FACTS
    },
    staleTime: 24 * 60 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
  })
}
